"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var react_slick_1 = __importDefault(require("react-slick"));
var dateformat_1 = __importDefault(require("dateformat"));
require("slick-carousel/slick/slick.css");
require("slick-carousel/slick/slick-theme.css");
var rssFeed_1 = require("../../../services/rssFeed");
var RssWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-sizing: border-box;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n"], ["\n  box-sizing: border-box;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n"])));
var HeaderContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 0px 20px 0px 20px;\n  min-height: 70px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"], ["\n  padding: 0px 20px 0px 20px;\n  min-height: 70px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"])));
var CarouselContainer = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding-top: 20px;\n  .item-title .item-description .item-pubdate {\n    color: white;\n  }\n\n  .item-title {\n    font-size: 25px;\n  }\n  .item-description {\n    font-style: italic;\n    font-size: 18px;\n  }\n  .item-pubdate {\n    font-size: 15px;\n  }\n  .item-image {\n    width: 100%;\n  }\n"], ["\n  padding-top: 20px;\n  .item-title .item-description .item-pubdate {\n    color: white;\n  }\n\n  .item-title {\n    font-size: 25px;\n  }\n  .item-description {\n    font-style: italic;\n    font-size: 18px;\n  }\n  .item-pubdate {\n    font-size: 15px;\n  }\n  .item-image {\n    width: 100%;\n  }\n"])));
var MainHeader = styled_components_1.default.h2(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: block;\n  margin: 0px;\n  padding: 0px;\n  font-size: 33px;\n"], ["\n  display: block;\n  margin: 0px;\n  padding: 0px;\n  font-size: 33px;\n"])));
var Card = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 0px 20px 0px 20px;\n  margin-bottom: 50px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 0px 20px 0px 20px;\n  margin-bottom: 50px;\n"])));
var TextContainer = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  width: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  width: ", ";\n"])), function (props) { return (props.cardHasImage ? '47%' : '70%'); });
var RssFeedWidget = function (_a) {
    var _b;
    var rssFeedProps = _a.rssFeedProps;
    var _c = (0, react_1.useState)(undefined), rssFeed = _c[0], setRssFeed = _c[1];
    if (!rssFeedProps) {
        return react_1.default.createElement("div", { style: { color: 'grey' } }, "props not found");
    }
    var url = rssFeedProps.url, visibleProperties = rssFeedProps.visibleProperties, theme = rssFeedProps.theme, interval = rssFeedProps.interval, itemCount = rssFeedProps.itemCount, refreshInterval = rssFeedProps.refreshInterval, styles = rssFeedProps.styles;
    var showChannelTitle = visibleProperties.channelTitle, showChannelDescription = visibleProperties.channelDescription, showItemTitle = visibleProperties.itemTitle, showItemDescription = visibleProperties.itemDescription, showItemPubDate = visibleProperties.itemPubDate, showItemImage = visibleProperties.itemImage;
    var mainContainerStyles = styles.mainContainerStyles, channelHeaderContainerStyles = styles.channelHeaderContainerStyles, channelTitleStyles = styles.channelTitleStyles, channelDescriptionStyles = styles.channelDescriptionStyles, itemCardStyles = styles.itemCardStyles, itemTitleStyles = styles.itemTitleStyles, itemDescriptionStyles = styles.itemDescriptionStyles, itemPubDateStyles = styles.itemPubDateStyles, itemImageStyles = styles.itemImageStyles, imageWrapperStyles = styles.imageWrapperStyles, textContainerStyles = styles.textContainerStyles;
    var refreshIntervalMilliSecond = refreshInterval ? refreshInterval * 1000 * 60 : 300000;
    (0, react_1.useEffect)(function () {
        var getAndSetData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var rssFeedResponse, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (0, rssFeed_1.getRssFeedAsJson)(url, itemCount)];
                    case 1:
                        rssFeedResponse = _a.sent();
                        setRssFeed(rssFeedResponse);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        setRssFeed(undefined);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        getAndSetData();
        var refresh = setInterval(function () {
            getAndSetData();
        }, refreshIntervalMilliSecond);
        return function () { return clearInterval(refresh); };
    }, [url, itemCount]);
    var slickSettings = {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: interval || 5000,
        arrows: false,
        swipeToSlide: false,
        pauseOnHover: false,
        pauseOnFocus: false
    };
    return (react_1.default.createElement(RssWrapper, { className: 'rss-wrapper', style: __assign({}, mainContainerStyles) },
        (showChannelTitle || showChannelDescription) && (react_1.default.createElement(HeaderContainer, { style: __assign({}, channelHeaderContainerStyles) },
            showChannelTitle && (react_1.default.createElement(MainHeader, { style: __assign({}, channelTitleStyles), className: 'channel-title' }, (rssFeed === null || rssFeed === void 0 ? void 0 : rssFeed.title) || '')),
            showChannelDescription && (react_1.default.createElement("h3", { className: 'channel-description', style: __assign({}, channelDescriptionStyles) }, (rssFeed === null || rssFeed === void 0 ? void 0 : rssFeed.description) || '')))),
        react_1.default.createElement(CarouselContainer, { className: 'carousel-wrapper' },
            react_1.default.createElement(react_slick_1.default, __assign({}, slickSettings), rssFeed &&
                ((_b = rssFeed.items) === null || _b === void 0 ? void 0 : _b.map(function (item) {
                    return (react_1.default.createElement("div", { key: item.title + '-' + Math.random() * 100, style: {
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: '0px 20px 0px 20px',
                            margin: '100px'
                        } },
                        react_1.default.createElement(Card, { className: 'card', theme: theme, style: __assign({}, itemCardStyles) },
                            react_1.default.createElement(TextContainer, { cardHasImage: showItemImage && Boolean(item.image), className: 'TextContainer', style: __assign({}, textContainerStyles) },
                                showItemTitle && (react_1.default.createElement("div", { style: __assign({}, itemTitleStyles) }, item.title)),
                                showItemDescription && (react_1.default.createElement("div", { style: __assign({}, itemDescriptionStyles) }, item.description)),
                                showItemPubDate && (react_1.default.createElement("div", { style: __assign({}, itemPubDateStyles) }, (0, dateformat_1.default)(item.published, 'ddd dd.mm.yyyy, hh:MM TT')))),
                            showItemImage && Boolean(item.image) && (react_1.default.createElement("div", { style: __assign({}, imageWrapperStyles), className: 'Image-contaier' },
                                react_1.default.createElement("img", { src: item.image, style: __assign({}, itemImageStyles) }))))));
                }))))));
};
exports.default = RssFeedWidget;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=RssFeedWidget.js.map